(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ValentinesHero"]) return;
  try {
    
    // Styling hero mobile navigation
    $('.js-mobile-nav-toggle').on('click', toggleMobileNav);
	$('.mobile-nav__return-btn').on('click', toggleSubNavReturn);

    function toggleMobileNav() {
      if ($('.js-mobile-nav-toggle').hasClass('mobile-nav--close')) {
        $('.site-header').removeClass('header__menu--is-open');
		$('.page-container').removeClass('page__menu--is-open');
      } else {
        $('.site-header').addClass('header__menu--is-open');
        $('.page-container').addClass('page__menu--is-open');
		
		if ($('.mobile-nav-wrapper').hasClass('sub-nav--is-open')) {
          $('.page-container').css('margin-top', '-55px');
        }
      }
	}

	function toggleSubNavReturn() {
	  $('.page-container').css('margin-top', '0');
	}

    var removeClass = function() {
      var ww = document.body.clientWidth;
      if (ww > 720) {
        $('.site-header').removeClass('header__menu--is-open');
		$('.page-container').removeClass('page__menu--is-open');
      }
    };

    $(window).resize(function(){
      removeClass();
    });

    removeClass();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-faq"]) return;
  try {
    
  $( function() {
    var icons = {
      header: "icon-closed",
      activeHeader: "icon-open"
    };
    $( "#accordion" ).accordion({
      icons: icons,
	  active: false,
	  collapsible: true
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-home-hero"]) return;
  try {
    
    // Styling hero mobile navigation
    $('.js-mobile-nav-toggle').on('click', toggleMobileNav);
	$('.mobile-nav__return-btn').on('click', toggleSubNavReturn);

    function toggleMobileNav() {
      if ($('.js-mobile-nav-toggle').hasClass('mobile-nav--close')) {
        $('.site-header').removeClass('header__menu--is-open');
		$('.page-container').removeClass('page__menu--is-open');
      } else {
        $('.site-header').addClass('header__menu--is-open');
        $('.page-container').addClass('page__menu--is-open');
		
		if ($('.mobile-nav-wrapper').hasClass('sub-nav--is-open')) {
          $('.page-container').css('margin-top', '-55px');
        }
      }
	}

	function toggleSubNavReturn() {
	  $('.page-container').css('margin-top', '0');
	}

    var removeClass = function() {
      var ww = document.body.clientWidth;
      if (ww > 720) {
        $('.site-header').removeClass('header__menu--is-open');
		$('.page-container').removeClass('page__menu--is-open');
      }
    };

    $(window).resize(function(){
      removeClass();
    });

    removeClass();

 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-home-product-slider"]) return;
  try {
    
$(document).ready(function(){
  $('.product-slider').slick();
  $('.slick-next').text('');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-home-review-slider"]) return;
  try {
    
$(document).ready(function(){
  $('.reviews-slider').slick();
  $('.slick-next').text('');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-home-social"]) return;
  try {
    
$(document).ready(function(){
  $( "#insta-feed-prev-arrow" ).click(function() {
    var leftPos = $('.insta-feed-container').scrollLeft();
  	$(".insta-feed-container").animate({scrollLeft: leftPos - 200}, 800);
  });
  $( "#insta-feed-next-arrow" ).click(function() {
    var leftPos = $('.insta-feed-container').scrollLeft();
  	$(".insta-feed-container").animate({scrollLeft: leftPos + 200}, 800);
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-accordion"]) return;
  try {
    
  $( function() {
    var icons = {
      header: "icon-closed",
      activeHeader: "icon-open"
    };
    $( "#accordion" ).accordion({
      	icons: icons,
		active: false,
  		collapsible: true
    });
	$( "#faq-accordion" ).accordion({
      	icons: icons,
		active: false,
  		collapsible: true
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-who-we-are-hero"]) return;
  try {
    
    // Styling hero mobile navigation
    $('.js-mobile-nav-toggle').on('click', toggleMobileNav);
	$('.mobile-nav__return-btn').on('click', toggleSubNavReturn);

    function toggleMobileNav() {
      if ($('.js-mobile-nav-toggle').hasClass('mobile-nav--close')) {
        $('.site-header').removeClass('header__menu--is-open');
		$('.page-container').removeClass('page__menu--is-open');
      } else {
        $('.site-header').addClass('header__menu--is-open');
        $('.page-container').addClass('page__menu--is-open');
		
		if ($('.mobile-nav-wrapper').hasClass('sub-nav--is-open')) {
          $('.page-container').css('margin-top', '-55px');
        }
      }
	}

	function toggleSubNavReturn() {
	  $('.page-container').css('margin-top', '0');
	}

    var removeClass = function() {
      var ww = document.body.clientWidth;
      if (ww > 720) {
        $('.site-header').removeClass('header__menu--is-open');
		$('.page-container').removeClass('page__menu--is-open');
      }
    };

    $(window).resize(function(){
      removeClass();
    });

    removeClass();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-who-we-are-social"]) return;
  try {
    
$(document).ready(function(){
  $( "#insta-feed-prev-arrow" ).click(function() {
    var leftPos = $('.insta-feed-container').scrollLeft();
  	$(".insta-feed-container").animate({scrollLeft: leftPos - 200}, 800);
  });
  $( "#insta-feed-next-arrow" ).click(function() {
    var leftPos = $('.insta-feed-container').scrollLeft();
  	$(".insta-feed-container").animate({scrollLeft: leftPos + 200}, 800);
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-why-cbd-hero"]) return;
  try {
    
    // Styling hero mobile navigation
    $('.js-mobile-nav-toggle').on('click', toggleMobileNav);
	$('.mobile-nav__return-btn').on('click', toggleSubNavReturn);

    function toggleMobileNav() {
      if ($('.js-mobile-nav-toggle').hasClass('mobile-nav--close')) {
        $('.site-header').removeClass('header__menu--is-open');
		$('.page-container').removeClass('page__menu--is-open');
      } else {
        $('.site-header').addClass('header__menu--is-open');
        $('.page-container').addClass('page__menu--is-open');
		
		if ($('.mobile-nav-wrapper').hasClass('sub-nav--is-open')) {
          $('.page-container').css('margin-top', '-55px');
        }
      }
	}

	function toggleSubNavReturn() {
	  $('.page-container').css('margin-top', '0');
	}

    var removeClass = function() {
      var ww = document.body.clientWidth;
      if (ww > 720) {
        $('.site-header').removeClass('header__menu--is-open');
		$('.page-container').removeClass('page__menu--is-open');
      }
    };

    $(window).resize(function(){
      removeClass();
    });

    removeClass();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-why-cbd-social"]) return;
  try {
    
$(document).ready(function(){
  $( "#insta-feed-prev-arrow" ).click(function() {
    var leftPos = $('.insta-feed-container').scrollLeft();
  	$(".insta-feed-container").animate({scrollLeft: leftPos - 200}, 800);
  });
  $( "#insta-feed-next-arrow" ).click(function() {
    var leftPos = $('.insta-feed-container').scrollLeft();
  	$(".insta-feed-container").animate({scrollLeft: leftPos + 200}, 800);
  });
});


  } catch(e) { console.error(e); }
})();
})();
